import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/dipf_logo.png';
import '../css/Header.css';

function Header({ isAuthenticated = false, onLogout = () => {}, currentUser = null }) {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <header className="header">
      <div className="logo-container">
        <Link to="/">
          <img src={logo} alt="Company Logo" className="logo-img" />
        </Link>
      </div>

      <nav className="nav-links">
        <Link to="/" className="nav-link">INCLASS</Link>

        {isAuthenticated ? (
          <>
            {currentUser?.name === 'Admin' ? (
              <>
                <Link to="/dashboard" className="nav-link">Dashboard</Link>
                <Link to="/inbox" className="nav-link">Nachrichten</Link>
              </>
            ) : (
              <>
                <Link to="/participant-info" className="nav-link">Ergebnisse</Link>
                <Link to="/my-notifications" className="nav-link">Zeitplan</Link>
              </>
            )}

            <div className="user-dropdown">
              <button
                className="user-name-button"
                onClick={() => setShowDropdown(!showDropdown)}
                onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
              >
                {currentUser?.name}
              </button>

              {showDropdown && (
                <div className="dropdown-menu">
                  {currentUser?.name !== 'Admin' && (
                    <Link
                      to="/profile"
                      className="dropdown-item"
                      onClick={() => setShowDropdown(false)}
                    >
                      Mein Profil
                    </Link>
                  )}
                  <button
                    onClick={onLogout}
                    className="dropdown-item"
                  >
                    Ausloggen
                  </button>
                </div>
              )}
            </div>
          </>
        ) : (
          <Link to="/login" className="nav-link">Einloggen</Link>
        )}
      </nav>
    </header>
  );
}

export default Header;
